module.exports = __webpack_public_path__ + "img/tutorial-pole.7e6814c0.png";